import { GTMFriendClick } from '../../../../../constants/analytics/GTM'
import { safeHTML } from '../../../../../utils/safeHTML'
import React from 'react'
import { useUser } from '../../../../../redux/reducer/user'
import { useActivePremiumAchievementIcon } from '../../../../../hooks/shared/achievements/useActivePremiumAchievementIcon'
import classNames from 'classnames'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'

export default function Item({ uid, username, score, iconId }) {
  const { profile: { uid: profileUid } = {} } = useUser()

  const iconImage = useActivePremiumAchievementIcon({ extraPremiumIcon: iconId })

  const callbacks = useApplicationCallbacks()
  const onClick = () => {
    if (profileUid !== uid) {
      callbacks.getFriend(uid)
      GTMFriendClick()
    }
  }

  return (
    <div
      className={classNames('friends__item', {
        friends__item_image: !!iconImage,
        'hide-level': true,
      })}
      onClick={onClick}
    >
      <div className={'friends__item-info'}>
        <div className={'friends__item-name'}>
          <strong className={'friends__item-name-text'}>{safeHTML(username)}</strong>
          {iconImage && (
            <img
              src={iconImage}
              className={'friends__item-image'}
              alt={''}
            />
          )}
        </div>
      </div>
      <div className={'friends__item-points'}>{score}</div>
    </div>
  )
}
